import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getVehicles,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteVehicle,
} from '../../lib/vehicles';

export const fetchVehicles = createAsyncThunk(
  'vehicles/fetchVehicles',
  async ({ pagination, options = {} }) => {
    const data = await getVehicles(pagination, options);

    return data;
  }
);

export const fetchVehicle = createAsyncThunk(
  'vehicles/fetchVehicle',
  async ({ vehicleId, options = {} }) => {
    const data = await getVehicle(vehicleId, options);
    return data;
  }
);

export const addVehicle = createAsyncThunk(
  'vehicles/addVehicle',
  async (vehicle, { rejectWithValue }) => {
    try {
      const data = await createVehicle(vehicle);
      return data;
    } catch (err) {

      console.error('Error in addVehicle action:', err);
      return rejectWithValue(err.response.data.description);
    }
  }
);

export const editVehicle = createAsyncThunk(
  'vehicles/updateVehicle',
  async ({ vehicleId, body }) => {
    const data = await updateVehicle(vehicleId, body);
    return data;
  }
);

export const removeVehicle = createAsyncThunk(
  'vehicles/deleteVehicle',
  async (vehicleId) => {
    await deleteVehicle(vehicleId);
    return vehicleId;
  }
);